import * as THREE from "three";
import type { TowerModel } from "./towerModel";
import type { WeaponPose } from "./towerView";
import { AimSpec, AimState, aimSpecOf, aimState, stepAim } from "./towerAim";
import { poseWeapon, weaponOrbit } from "./towerMotion";

/**
 * A tower standing on show with nothing to shoot (the hub's stands): its weapon keeps the sentry's look-around a
 * battle tower falls into between waves (towerAim.ts idleLook) — the same code the level's towers run, without a
 * sim. Call `update` instead of `rig.update`.
 */
export class TowerIdle {
  private pose: WeaponPose | null = null;
  private readonly aim: AimState | null;
  private readonly spec: AimSpec;
  private readonly orbit: THREE.Vector3 | null;

  constructor(private readonly model: TowerModel, arch: string, seed: number) {
    this.aim = model.weapon && !model.name.startsWith("base_") ? aimState(0, seed) : null;
    this.spec = aimSpecOf(arch, model.name);
    this.orbit = weaponOrbit(model, arch, model.storeys);
  }

  update(dt: number): void {
    const yaw = this.aim ? stepAim(this.aim, this.spec, null, 0, dt).yaw : 0;
    if (this.aim || this.model.weapon) this.pose = poseWeapon(this.model, this.pose, yaw, dt, this.orbit);
    else this.model.rig.update(dt);
  }
}
